import { Factory, Recycle, Wind } from "lucide-react";

const sectors = [
  {
    id: "energy",
    icon: Factory,
    title: "Energy",
    tag: "Conventional Energy",
    items: [
      "Oil & Gas Processing",
      "Refineries",
      "Petrochemicals",
      "Pipelines",
      "Power & Water",
      "Infrastructure",
    ],
    accent: "from-primary/90 to-primary",
  },
  {
    id: "transition",
    icon: Recycle,
    title: "Energy Transition",
    tag: "Low Carbon",
    items: [
      "Biofuels",
      "Waste to Energy",
      "Decarbonization",
      "Desulfurization",
      "Flare Solutions",
      "Digitalization",
    ],
    accent: "from-emerald-700 to-emerald-900",
  },
  {
    id: "green",
    icon: Wind,
    title: "Green Energy",
    tag: "Zero Carbon",
    items: [
      "Green Hydrogen",
      "Green Ammonia",
      "Green Chemicals",
      "PV Solar",
      "Wind",
      "Storage & Shipping",
    ],
    accent: "from-lime-600 to-emerald-700",
  },
];

export default function Sectors() {
  return (
    <section id="sectors" data-testid="sectors-section" className="py-20 lg:py-28 bg-white">
      <div className="container-wide">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-primary">
              Our Sectors
            </p>
            <h2 className="mt-3 font-display font-bold text-3xl sm:text-4xl lg:text-5xl text-foreground">
              Energy Solution Provider
            </h2>
          </div>
          <p className="lg:max-w-md text-base text-muted-foreground leading-relaxed">
            From conventional energy operations to fully zero‑carbon green projects, GEES delivers across the entire spectrum of the energy transition.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {sectors.map((s) => (
            <article
              key={s.id}
              data-testid={`sector-card-${s.id}`}
              className="relative rounded-2xl border border-border bg-white p-7 hover-lift overflow-hidden"
            >
              <div className={`absolute -top-16 -right-16 h-48 w-48 rounded-full bg-gradient-to-br ${s.accent} opacity-10`} />
              <span className="relative inline-flex h-12 w-12 items-center justify-center rounded-xl bg-primary text-primary-foreground">
                <s.icon className="h-5 w-5" />
              </span>
              <p className="relative mt-5 text-xs font-bold uppercase tracking-[0.2em] text-muted-foreground">
                {s.tag}
              </p>
              <h3 className="relative mt-1 font-display font-bold text-2xl text-foreground">
                {s.title}
              </h3>
              <ul className="relative mt-5 space-y-2.5">
                {s.items.map((it) => (
                  <li
                    key={it}
                    className="flex items-center gap-2.5 text-sm text-foreground/80"
                  >
                    <span className="h-1.5 w-1.5 rounded-full bg-accent" />
                    {it}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
